import { Table, Tag } from "antd";
import { CustomerPersonalDetailsCommentsAndHistoryPanel } from "../types";
import { useEffect, useState } from "react";
import axiosInstance from "../../../axios";
import TheSpinner from "../../TheSpinner";
import { TABLE_LIMIT } from "../../constants";

export function SubscriptionHistory(
  props: CustomerPersonalDetailsCommentsAndHistoryPanel
) {
  const [page, setPage] = useState(1);
  const { studentDetails, subscriptionStatus } = props;
  const [loading, setLoading] = useState<boolean>(true);
  const [subscriptionHistory, setSubscriptionHistory] = useState<any[]>([]);
  const [subscriptionHistoryMeta, setSubscriptionHistoryMeta] = useState({
    total: 0,
  });

  useEffect(() => {
    getStudentSubscriptionHistory();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [page, subscriptionStatus]);

  async function getStudentSubscriptionHistory() {
    try {
      const { data } = await axiosInstance.get(
        "/v1/cre/student/subscription-history",
        {
          params: {
            student_id: studentDetails.studentId,
            page: page,
            limit: TABLE_LIMIT,
          },
        }
      );
      console.log(data);
      if (data.success) {
        setSubscriptionHistory(data?.data?.result);
        setSubscriptionHistoryMeta(data?.data?.meta);
      }
    } catch (error) {}
    setLoading(false);
  }

  const columns = [
    {
      title: "Status",
      dataIndex: "status",
      key: "status",
      render: (_: any, { status }: { status: string }) => (
        <Tag color={status === "ACTIVE" ? "green" : "red"} key={status}>
          {status}
        </Tag>
      ),
    },
    {
      title: "Subscription Start Date",
      dataIndex: "start_date",
      key: "start_date",
      // className: "tail-bg-green-500"
    },
    {
      title: "Subscription End Date",
      dataIndex: "end_date",
      key: "end_date",
      // className: "tail-bg-red-500",
    },
  ];

  if (loading) {
    return <TheSpinner />;
  }

  return (
    <div>
      <Table
        dataSource={subscriptionHistory}
        columns={columns}
        scroll={{ x: "100%" }}
        pagination={{
          total: subscriptionHistoryMeta.total,
          pageSize: TABLE_LIMIT,
          onChange: (page, pageSize) => setPage(page),
          showSizeChanger: false,
          current: page,
        }}
        bordered={true}
      />
    </div>
  );
}
